// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1u36j","title":"Images45_title__2rHJv","images":"Images45_images__181xh"};